import { render, staticRenderFns } from "./PolicyDocumentsPanel.vue?vue&type=template&id=090dd9fc&scoped=true"
import script from "./PolicyDocumentsPanel.vue?vue&type=script&lang=js"
export * from "./PolicyDocumentsPanel.vue?vue&type=script&lang=js"
import style0 from "./PolicyDocumentsPanel.vue?vue&type=style&index=0&id=090dd9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090dd9fc",
  null
  
)

export default component.exports